import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=1bae931d&scoped=true&"
import script from "./courseList.vue?vue&type=script&lang=js&"
export * from "./courseList.vue?vue&type=script&lang=js&"
import style0 from "./courseList.vue?vue&type=style&index=0&id=1bae931d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae931d",
  null
  
)

export default component.exports